import { captureConversion } from "./analytics";

/**
 * `store_badge_click`: the last step of the web funnel we can measure.
 *
 * Until now no click on an App Store or Google Play button was recorded
 * anywhere: PostHog held 30 pageviews and no download event in 30 days, so the
 * one question the site exists to answer (which page sends people to the
 * store?) was unanswerable. Spec: LL-0280 outcome-join L5,
 * threads-letsloop/deliverables/LL-0280-outcome-join/spec-2026-10-19.md.
 *
 * Goes through captureConversion(), so both sinks stay consent-gated exactly as
 * every other conversion (LL-0024): nothing is emitted before the visitor
 * accepts analytics cookies.
 */
export type Store = "ios" | "android";

export function storeFromUrl(href: string): Store | null {
  try {
    const host = new URL(href).hostname;
    if (host === "apps.apple.com" || host === "itunes.apple.com") return "ios";
    if (host === "play.google.com") return "android";
  } catch {
    // relative or malformed href: not a store link
  }
  return null;
}

export function trackStoreClick(href: string, placement: string): void {
  const store = storeFromUrl(href);
  if (!store) return; // e.g. the beta page points badges at /beta, not a store
  captureConversion("store_badge_click", {
    store,
    page_path: window.location.pathname,
    placement,
  });
}
